<nb-card>
  <nb-card-header>
    <div class="logo-container">
      <a href="#"><img width="" alt="log" src="../../../../assets/images/logo-alternative.svg" href="#"></a>
    </div>
  </nb-card-header>
  <nb-alert *ngIf="errors?.length" outline="danger" role="alert">
    <p class="alert-title"><b>Corrija seus dados!</b></p>
    <ul class="alert-message-list">
      <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
    </ul>
  </nb-alert>
  <nb-card-body>
    <nb-alert outline="success" role="alert" *ngIf="status">
      <ul class="alert-message-list">
        <li class="alert-message">{{ status }}</li>
      </ul>
    </nb-alert>
    <nb-card-footer>
      <section class="another-action" aria-label="Sign in" *ngIf="status">
        Voltar ao <a class="text-link" routerLink="/">Login</a>
      </section>
    </nb-card-footer>
  </nb-card-body>

</nb-card>